module.exports = __webpack_public_path__ + "img/ИФ-1(А)-034.3419f8cb.png";